import {
  Select,
  DatePicker,
  Button,
  Spin,
  Tag,
  message,
  Input,
  Alert,
  notification,
  Result,
} from "antd";
import React, { useCallback, useEffect, useState, useRef } from "react";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";

const dateFormat = "DD-MM-YYYY HH:mm:ss";
const { Option } = Select;
const ip = process.env.REACT_APP_IP;
const Export_Ecell = () => {
  const [sent_user_name, setsent_user_name] = useState("");
  const [sent_user, setsent_user] = useState();
  const [users, setUsers] = useState([]);
  const [sent_startCover, setsent_startCover] = useState();
  const [sent_endCover, setsent_endCover] = useState();
  const [confirm, setconfirm] = useState(true);
  const [loadding, setLoading] = useState(false);

  function onChange_timestart(value, dateString) {
    setsent_startCover(value);
  }
  function onChange_timeend(value, dateString) {
    setsent_endCover(value);
  }

  const userRedux = useSelector((state) => {
    return state.user;
  });
  function onchange_user(value) {
    let name = users.find((e) => e.id === value);
    setsent_user_name(name.name);
    setsent_user(value);
  }
  const getUser = useCallback(async () => {
    let all = {
      id: 0,
      name: "ຕົວແທນທັງໝົ້ດ",
    };
    let link = `${ip}sell_online/users`;
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    try {
      const response = await fetch(link, requestOptions);
      const result_1 = await response.json();
      if (result_1.status === 200) {
        if (userRedux.level === "manager" || userRedux.level === "acc") {
          let u = result_1.data;
          u.unshift(all);
          setUsers(u);
        } else {
          const uu = result_1.data.find((id) => id.id === userRedux.user_id);
          setUsers([uu]);
        }
      } else {
      }
    } catch (error) {
      return console.log("error", error);
    }
  }, [userRedux.level, userRedux.user_id]);

  useEffect(() => {
    getUser();
  }, [getUser]);
  useEffect(() => {
    if (
      sent_user === undefined ||
      sent_startCover === undefined ||
      sent_endCover === undefined
    ) {
      setconfirm(true);
    } else {
      setconfirm(false);
    }
  });
  return (
    <div>
      <Select
        placeholder="ເລືອກຕົວແທນ"
        optionFilterProp="children"
        style={{ width: "100%" }}
        onChange={onchange_user}
      >
        {users.map((value) => {
          return (
            <Option key={value.id} value={value.id}>
              {value.name} ({value.user})
            </Option>
          );
        })}
      </Select>
      <hr />

      <div className="d-flex flex-row">
        <div className="flex-fill">
          <div className="d-flex flex-row">
            <div className="mr-1 ml-1">ເລີ່ມແຕ່ວັນທີ::</div>
            <div className="flex-fill mr-1 ml-1">
              <DatePicker
                placeholder="ເລີ່ມແຕ່ວັນທີ"
                style={{ width: "100%" }}
                showTime
                onChange={onChange_timestart}
                format={dateFormat}
              />
            </div>
          </div>
        </div>
        <div className="flex-fill">
          <div className="d-flex flex-row px-1">
            <div className="mr-1 ml-1">ສິ້ນສຸດວັນທີ::</div>
            <div className="flex-fill mr-1 ml-1">
              <DatePicker
                style={{ width: "100%" }}
                placeholder="ສິ້ນສຸດວັນທີ"
                showTime
                onChange={onChange_timeend}
                format={dateFormat}
              />
            </div>
          </div>
        </div>
        <div className="flex-fill">
          <Button
            disabled={confirm}
            onClick={() => {
              getData();
            }}
            style={{ width: "100%" }}
            type="primary"
            loading={loadding}
          >
            {" "}
            ຄົ້ນຫາ{" "}
          </Button>
        </div>
      </div>

      {loadding && (
        <div className="example">
          <Spin tip="ກຳລັງດາວໂຫລດ..." size="large" />
        </div>
      )}
    </div>
  );
  function getData() {
    setLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var raw = JSON.stringify({
      start: sent_startCover,
      end: sent_endCover,
      agent: sent_user,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    let link = `${ip}export_data/all`;
    fetch(link, requestOptions)
      .then((response) => {
        console.log(response.status);
        if (response.status != 200) {
          setLoading(false);
        }
        return response.blob();
      })
      .then((blob) => {
        // 2. Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", `${userRedux.user}.xlsx`);
        // 3. Append to html page
        document.body.appendChild(link);
        // 4. Force download
        link.click();
        // 5. Clean up and remove the link
        link.parentNode.removeChild(link);
        setLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
      });
  }
};

export default Export_Ecell;
